<div
  class="modal fade"
  id="modalGerarListaContatos"
  tabindex="-1"
  aria-labelledby="modalGerarListaContatosLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title fs-5" id="exampleModalLabel">
           <div class="position-relative">
            <input
              #nomeInput
              type="text"
              id="nomeListaContatos"
              class="form-control form-nome-lista"
              placeholder="Nome da lista"
              [(ngModel)]="novaListaContato.nomeLista"
              (change)="onChangeNomeLista($event)"
            />
          </div>
        </h3>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="cancelarListaContato()"
        ></button>
      </div>
      <div class="modal-body">
        <dl class="grid grid-cols-12 gap-y-4">
          <dt class="col-span-9 font-medium items-center flex">
            Quantos contatos você deseja baixar?
          </dt>
          <dd class="col-span-3">
            <div class="position-relative">
              <input
                #qtdInput
                type="text"
                class="form-control"
                placeholder="Nº contatos" 
                (input)="onNumeroContatosChange($event)"
                id="selecionarNumeroContatosDownload"
                [(ngModel)]="novaListaContato.qtdeExtracao"
              />
            </div>
          </dd>

          <ul class="space-y-4 col-span-12">
            <li class="flex items-center justify-between">
              <span class="font-normal">A lista irá consumir</span>
              <span class="font-semibold"
                >{{ qtdRegistros | formatarNumeroBR }} pts</span
              >
            </li>
            <li class="flex items-center justify-between">
              <span class="font-normal">Seu saldo é</span>
              <span>{{ saldo.quantidade | formatarNumeroBR }} pts</span>
            </li>
            <li
              class="flex items-center justify-between"
              [class.flex]="mostrarSaldoCreditos"
              [class.hidden]="!mostrarSaldoCreditos"
            >
              <span class="font-normal">Você ficará com</span>
              <span>{{ saldoRestante | formatarNumeroBR }} pts</span>
            </li>
            <li
              class="items-center justify-between text-brand-purple-300"
              [class.flex]="mostrarCreditosFaltantes"
              [class.hidden]="!mostrarCreditosFaltantes"
            >
              <span class="font-normal">Faltam</span>
              <span>{{ saldoFaltante | formatarNumeroBR }} pts</span>
            </li>
            <li class="justify-start" *ngIf="!podeFazerRecarga && mostrarBotaoRecarga">
              <span style="color: #FFA500">A quantidade está acima do seu limite configurado</span>
            </li>
            <li
              *ngIf="podeFazerRecarga"
              class="items-center justify-end"
              [class.flex]="mostrarBotaoRecarga"
              [class.hidden]="!mostrarBotaoRecarga"
              id="btnFazerRecarga"              
            >
              <button class="btn btn-primary" id="openRecargaModal" data-bs-toggle="modal" data-bs-target="#modalRecarga" data-bs-dismiss="modal">
                Fazer recarga
              </button>
            </li>
          </ul>
        </dl>
      </div>
      <div class="modal-footer flex items-center justify-end gap-6">
        <div>
          <button
            *appTemPermissao="EnumPermissao.GerarListaContatos"
            type="button"
            class="btn btn-primary"
            [disabled]="processando"
            (click)="gerarListaContato()"
            style="min-width: 115px"
          >
            <span *ngIf="!processando">Confirmar</span>
            <app-carregando
              [showCarregando]="processando"
              [isChart]="false"
            ></app-carregando>
          </button>
        </div>
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
          (click)="cancelarListaContato()"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-recarga></app-modal-recarga>
